module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/2-9010cdc9845a0db0c397c58bdcbb4f3a.webp";